import BaseTooltip from 'components/Tooltips/BaseTooltip';
import { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa6';
import { usePersonnel } from '../../contexts/PersonnelContext';
import Modal from './components/Modal';
import Table from './components/Table';

const renderResponderTooltip = (id, text) => (
  <Tooltip id={id} className="responder-tooltip">
    {text}
  </Tooltip>
);

export const PersonnelList = () => {
  const [showModal, setShowModal] = useState(false);
  const { personnel, fetchPersonnel, lastUpdateTime } = usePersonnel();

  return (
    <div
      className="p-3 rounded-2"
      style={{
        background: '#0b1826',
      }}
    >
      <div className="d-flex w-100">
        <h4>Personnel</h4>
        <BaseTooltip id="personnel-list-create" text="This feature is not yet implemented">
          <Button className="ms-auto btn-transparent">
            <FaPlus />
          </Button>
        </BaseTooltip>
      </div>
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => {
          fetchPersonnel();
        }}
      >
        <div style={{ fontSize: '0.8em', marginBottom: '10px', color: '#ccc' }}>
          {lastUpdateTime ? `Last updated: ${lastUpdateTime.toLocaleTimeString()} ⟳` : 'Loading...'}
        </div>
      </div>
      {Object.keys(personnel).length > 0 ? (
        <Table personnel={personnel} />
      ) : (
        <p className="text-muted">No personnel available.</p>
      )}
      <Modal show={showModal} handleShow={() => setShowModal(false)} />
    </div>
  );
};
